jQuery(function ($) {
  function updateSingleProductPage() {
    // Ensure the script only runs on the "/product/coin/" page
    if (!window.location.pathname.includes("/product/coin/")) {
      return; // Exit if not on the coin page
    }
    // Extract the "coin" parameter from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const coinSlug = urlParams.get("coin"); // Example: ?coin=bitcoin

    if (!coinSlug) {
      $(".single-product-title h1").text("No Cryptocurrency Selected");
      $(".single-product .entry-content p:first").text("No cryptocurrency data available.");
      $("title").text("Cryptocurrency Not Found – Midchains");
      return;
    }

    $.ajax({
      url: "https://dev-gateway.midchains.com/api/v1/cryptocurrencies",
      method: "GET",
      dataType: "json",
      success: function (data) {
        // Find the cryptocurrency by slug
        let crypto = data.find(c => c.slug.toLowerCase() === coinSlug.toLowerCase());

        if (crypto) {
          // ✅ Update Page Title
          document.title = `${crypto.slug.charAt(0).toUpperCase() + crypto.slug.slice(1)} (${crypto.symbol}) – Midchains`;

          // ✅ Update Main Image Above <h1>
          $(".single-product-title img")
            .attr("src", crypto.logo) // Main image
            .attr("alt", crypto.slug) // Alternative text
            .attr("srcset", `${crypto.logo} 1503w, ${crypto.logo} 300w, ${crypto.logo} 1024w, ${crypto.logo} 150w, ${crypto.logo} 768w`)
            .attr("sizes", "(max-width: 1503px) 100vw, 1503px");

          // ✅ Update Name & Symbol
          $(".single-product-title h1").html(
            `${crypto.slug.charAt(0).toUpperCase() + crypto.slug.slice(1)} <span>${crypto.symbol}</span>`
          );
          // ✅ Format number and remove trailing zeros (if any)
          const formattedPrice = parseFloat(crypto.price).toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 8
          });

          $(".product-statistic__item.last--price h4").text(`${formattedPrice} USD`);
          // ✅ Update Price Change
          let priceChangeElem = $(".product-statistic__item.price--change h4");
          let priceChange = crypto.priceChangePercent.toFixed(2) + " %";
          priceChangeElem.text(priceChange);

          // ✅ Remove old color classes and add new one
          priceChangeElem.removeClass("green red");
          if (crypto.priceChangePercent > 0) {
            priceChangeElem.addClass("green");
          } else if (crypto.priceChangePercent < 0) {
            priceChangeElem.addClass("red");
          }

          // ✅ Update Status
          $(".product-statistic__item.product--status h4").text(crypto.status);

          // ✅ Update the first paragraph inside `.entry-content` with the cryptocurrency description
          $(".entry-content p:first").text(crypto.description);
        } else {
          // ❌ If Not Found - Set Placeholder Values
          $(".single-product-title img").attr("src", "").attr("alt", "Not Found");
          $(".single-product-title h1").text("Cryptocurrency Not Found");
          $(".product-statistic__item.last--price h4").text("No Price Available");
          $(".product-statistic__item.price--change h4").text("No Data").removeClass("green red");
          $(".product-statistic__item.product--status h4").text("Unknown");

          // ❌ Update Title for Not Found
          document.title = "Cryptocurrency Not Found – Midchains";

          // Show fallback text if no crypto is found
          $(".single-product .entry-content p:first").text("Cryptocurrency description not available.");
        }
      },
      error: function () {
        console.error("Failed to fetch cryptocurrency data.");
        $(".single-product .entry-content p:first").text("Error fetching cryptocurrency data.");
        document.title = "Error Fetching Data – Midchains";
      }
    });
  }

  // Initial update (Runs once on page load)
  updateSingleProductPage();
});
// Fixed header adjustments
const $body = document.querySelector("body");
const $header = document.querySelector(".header");

function stickyHeader(header_hight) {
  if (window.pageYOffset > header_hight) {
    $header.classList.add("sticky");
  } else {
    $header.classList.remove("sticky");
  }
}

// Find all select elements
var selectElements = document.querySelectorAll(
  ".modal-dialog .main-inputs .wpcf7-select"
);

// Loop through each select element and disable the first option without a value
selectElements.forEach(function (selectElement) {
  if (
    selectElement &&
    selectElement.options.length > 0 &&
    !selectElement.options[0].value
  ) {
    selectElement.options[0].disabled = true;
    selectElement.options[0].selected = true;
  }
});


if ($header) {
  const header_hight = $header.offsetHeight;
  window.addEventListener("load", function () {
    stickyHeader(header_hight);
  });
  document.addEventListener("scroll", function () {
    stickyHeader(header_hight);
  });
}
//adds modals
jQuery(function ($) {
  $(".modal-private-clients").attr("data-bs-toggle", "modal");
  $(".modal-private-clients").attr("data-bs-target", "#modal-private-cliets");
});
jQuery(function ($) {
  $(".modal-contact-form").attr("data-bs-toggle", "modal");
  $(".modal-contact-form").attr("data-bs-target", "#modal-contact");
});

// Home Matters Section Tabs
const $home_matters = document.getElementById("home_matters_content");
if ($home_matters) {
  let $home_matters_items = $home_matters.querySelectorAll(
    ".home-matters__item"
  );
  let $home_matters_first = $home_matters_items[0];
  $home_matters_first.classList.add("show", "active");
  let $home_matters_item_count = 0;
  $home_matters_items.forEach((item) => {
    $home_matters_item_count++;
    item.setAttribute("id", `matter_item_${$home_matters_item_count}`);
    item.setAttribute(
      "aria-labelledby",
      `matter_item_${$home_matters_item_count}_tab`
    );
  });
}

// Single Post Share Dropdown
const dropdown_toggle = document.querySelector(".btn-share");
const share_menu = document.querySelector(".share-menu");
const share_id = "single_share";

if (dropdown_toggle && share_menu) {
  dropdown_toggle.setAttribute("id", share_id);
  dropdown_toggle.setAttribute("role", "button");
  dropdown_toggle.setAttribute("data-toggle", "dropdown");
  dropdown_toggle.setAttribute("aria-haspopup", "true");
  dropdown_toggle.setAttribute("aria-expanded", "false");

  share_menu.setAttribute("aria-labelledby", share_id);

  dropdown_toggle.addEventListener("click", (e) => {
    e.preventDefault();
    share_menu.classList.toggle("show");
  });
}

// Single Post Scrollbar
function scrollBar(id) {
  let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  let height =
    document.documentElement.scrollHeight -
    document.documentElement.clientHeight;
  let scrolled = (winScroll / height) * 100;
  document.getElementById(id).style.width = scrolled + "%";
}

const $scrollbar = document.querySelector(".scrollbar");
const $api_scrollbar = document.querySelector(".api-scrollbar");

if ($scrollbar) {
  const $close_trigger = $scrollbar.querySelector(".btn-close");

  $close_trigger.addEventListener("click", function () {
    $scrollbar.classList.add("hide");
  });

  document.addEventListener("scroll", function () {
    scrollBar("scrollBar");
  });
}

if ($api_scrollbar) {
  document.addEventListener("scroll", function () {
    scrollBar("scrollBarApi");
  });
}

const vacancy_form = document.querySelector(".vacancy-form");

if (vacancy_form) {
  const form_controls = vacancy_form.querySelectorAll(".form-control");
  form_controls.forEach((form_control) => {
    let form_control_parent = form_control.closest(".form-control__wrap");
    form_control.addEventListener("focus", (e) => {
      form_control_parent.classList.add("focused");
    });
  });

  const form_controls_select = vacancy_form.querySelectorAll(
    "select.form-control"
  );
  form_controls_select.forEach((select) => {
    select.addEventListener("focus", (e) => {
      form_controls_select.forEach((element) => {
        let form_control_select_parent = element.closest(".form-control__wrap");
        form_control_select_parent.classList.add("focused");
      });
    });
  });
}

const vacancy_country_select = document.querySelector(".wpcf7-country_auto");
const vacancy_state_select = document.querySelector(".wpcf7-state_auto");
const vacancy_city_select = document.querySelector(".wpcf7-city_auto");

function vacancy_form_select_remove_first(select) {
  if (select) {
    let select_options = select.querySelectorAll("option");

    select_options.forEach((option) => {
      let data_id = option.getAttribute("data-id");

      if (data_id === "0") {
        option.text = "";
      }
    });
  }
}

vacancy_form_select_remove_first(vacancy_country_select);
vacancy_form_select_remove_first(vacancy_state_select);
vacancy_form_select_remove_first(vacancy_city_select);

// file upload customization
let resumeInput = document.getElementById("resume_input");
let resumeContainer = document.getElementById("resume_container");
let wpcf7Elm = document.querySelector(".wpcf7");
if (resumeInput) {
  resumeInput.onchange = function () {
    resumeContainer.innerHTML = resumeInput.files[0].name;
    resumeContainer.classList.add("chosen");
  };
}
if (wpcf7Elm) {
  wpcf7Elm.addEventListener(
    "wpcf7submit",
    function () {
      resumeInput.value = null;
      resumeContainer.innerHTML = "";
      resumeContainer.classList.remove("chosen");

      const form_controls = vacancy_form.querySelectorAll(".form-control");
      form_controls.forEach((form_control) => {
        let form_control_parent = form_control.closest(".form-control__wrap");
        form_control_parent.classList.remove("focused");
      });

      vacancy_form_select_remove_first(vacancy_country_select);
      vacancy_form_select_remove_first(vacancy_state_select);
      vacancy_form_select_remove_first(vacancy_city_select);
    },
    false
  );
}

// init popover
window.bootstrap = require("../node_modules/bootstrap/dist/js/bootstrap.bundle");

var popoverTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="popover"]')
);
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl);
});

// Accordion Item Adjustment
const $accordion_collapses = document.querySelectorAll(".accordion-collapse");

if ($accordion_collapses) {
  $accordion_collapses.forEach((collapse) => {
    let parent = collapse.parentNode;
    collapse.addEventListener("show.bs.collapse", function () {
      parent.classList.add("show");
    });
    collapse.addEventListener("hide.bs.collapse", function () {
      parent.classList.remove("show");
    });
  });
}

// FAQ Accordion
const $faq_accordion = document.getElementById("accordion_faq");
if ($faq_accordion) {
  let $faq_accordion_items = $faq_accordion.querySelectorAll(".accordion-item");

  let acc_count = 0;
  $faq_accordion_items.forEach((item) => {
    acc_count++;

    let $acc_header = item.querySelector(".accordion-header");
    let $acc_btn = item.querySelector(".accordion-button");
    let $acc_collapse = item.querySelector(".accordion-collapse");

    if (acc_count === 1) {
      item.classList.add("show");
      $acc_btn.classList.remove("collapsed");
      $acc_btn.setAttribute("aria-expanded", "true");
      $acc_collapse.classList.add("show");
    }

    $acc_header.setAttribute("id", `heading_${acc_count}`);
    $acc_btn.setAttribute("data-bs-target", `#collapse_${acc_count}`);
    $acc_btn.setAttribute("aria-controls", `collapse_${acc_count}`);
    $acc_collapse.setAttribute("id", `collapse_${acc_count}`);
    $acc_collapse.setAttribute("aria-laballedby", `heading_${acc_count}`);
  });
}

// Custom ADGM menu handler
const adgm_toggle = document.querySelector(".menu-adgm");
const adgm_output = document.querySelector("#adgm_menu_widget");
let adgm_input = document.querySelector(
  ".menu-adgm .wp-block-navigation-item__description"
);

if (adgm_output && adgm_input) {
  adgm_input.innerHTML = adgm_output.innerHTML;
}

if (adgm_toggle) {
  adgm_toggle.addEventListener("click", function (e) {
    e.preventDefault();
    adgm_input.classList.toggle("show");
    this.classList.toggle("open");
  });
}

// remove <br> for titles
let titles = [document.querySelector(".home-top__content h1")];

if (titles && window.innerWidth < 992) {
  window.onload = function () {
    titles.forEach(function (title) {
      if (title) {
        title.innerHTML = title.innerHTML.replaceAll("<br>", " ");
      }
    });
  };
}

jQuery(function ($) {
  let pageTitles = $(".section__title h2");
  if (pageTitles) {
    if ($(window).innerWidth() < 992) {
      pageTitles.each(function () {
        let str = $(this).html();
        let res = str.replaceAll("<br>", " ");
        $(this).html(res);
      });
    }
  }
});
jQuery(function ($) {
  // on focus
  $(".wpcf7-form .form-control").focus(function () {
    $(this).parent().siblings("label").addClass("has-value");
  });
  $(".wpcf7-form .form-control").focusout(function () {
    var text_val = $(this).val();
    if (text_val === "") {
      $(this).parent().siblings("label").removeClass("has-value");
    }
  });
});

const $home_partners_images = document.querySelectorAll(
  ".home-partners .wp-block-image"
);

if ($home_partners_images) {
  $home_partners_images.forEach(function (image) {
    image.classList.add("swiper-slide");
  });
}

const $api_search_toggle = document.querySelector(".api-search__toggle");
const $api_search_input = document.querySelector(".api-search__input");

if ($api_search_input && $api_search_toggle) {
  $api_search_toggle.addEventListener("click", function () {
    this.classList.add("hide");
    $api_search_input.classList.add("show");
  });
}


